module.exports = __webpack_public_path__ + "static/media/Michal Lakomski.d21781f9.jpg";